class DeviceCtrl  
  @$inject: ["$rootScope", "$scope", "$state", "$stateParams", "Device"]  
  constructor: ($rootScope, $scope, $state, $stateParams, Device)->            
    $scope.ratio = 1
    $scope.disconnect = false
    Device.get({_id: $stateParams._id}).$promise.then (result)=>
      $scope.device = result   
      $scope.device.resize = 1
    $scope.resize = (size)->
      $scope.device.resize = size
      console.log $scope.device.resize

module.exports = DeviceCtrl




// WEBPACK FOOTER //
// ./src/component/device/remote/controller.coffee